import React, { useState, useEffect, useRef } from 'react';

import Header from "../../Components/Header/Header";
import { LeftSettings } from './LeftSettings';

import AGS from './Dashboard/GeneralSettings';
import AUS from './Dashboard/UserSettings';
import CUS from './Common/UserSettings';
import ASS from './Dashboard/StationSettings'; 
import ATM from './Dashboard/TemplateManagement';

import AULDGS from './ULD/GeneralSettings';
import AULDRS from './ULD/RegionSettings';
import AULDARS from './ULD/AccessRightsSettings';
import AULDNS from './ULD/NotificationSettings';
import AULDIS from './ULD/InactiveUldSettings';
import AULDSS from './ULD/StationSettings';
import AULDRtS from './ULD/ReportSettings';
import AULDMS from './ULD/MessageSettings';
import AULDSAS from './ULD/StockAllotmentSettings';

import ARFSNS from './RFS/NotificationSettings';
import ARFSTS from './RFS/TruckerSettings';
import ARFSSS from './RFS/StationSettings';
import AULDS from './RFS/UldSettings';
import ARFSRS from './RFS/RegionSettings';

import ASRGS from './ASR/GeneralSettings';
import ASRRSS from './ASR/RecoveryStationSettings';
import ASRFS from './ASR/FileManagementSettings';
import ASRDS from './ASR/DepartmentSettings';

import FUS from './FDASH/UserSettings';
import FSS from './FDASH/StationSettings';
import FDS from './FDASH/DepartmentSettings';
import FTS from './FDASH/TimeZoneSettings';
import FDVS from './FDASH/DriverVisitorSettings';

import FSMGS from './FSM/GeneralSettings';
import FSMSRS from './FSM/ShipmentRecordSettings';
import FSMACI from './FSM/AddCategoryInvoice';
import FSMCS from './FSM/CustomerSettings';
import FSMLS from './FSM/LocationSettings';
import FSMQS from './FSM/QuotationSettings';
import FSMSR from './FSM/StationRatesSettings';     
import FSMQO from './FSM/QuotationOrgSettings'; 

import FULDGS from './FULD/GeneralSettings';

import HGS from './HADMIN/GeneralSettings';
import HUS from './HADMIN/UserSettings';
import HSS from './HADMIN/StationSettings';
import HWS from './HADMIN/WarehouseSettings';
import HTM from './HADMIN/TemplateManagement';

import HULDAirline from './HULD/AirlineSettings';
import HULDSCM from './HULD/SCM';
import HULDAgent from './HULD/AgentSettings';

import HSPLDC from './SPL/DoorConfiguration';  
import HSPLSS from './SPL/SlotSettings';
import HSPLTS from './SPL/TruckerSetting';
import HSPLAS from './SPL/AirlineSetting';
import HSPLRS from './SPL/ResourceSettings';

import HSRGS from './HSR/GeneralSettings';
import HSRAB from './HSR/AddressBook';
import HSRRSS from './HSR/RecoveryStationSettings';

import FDVDS from './DVR/DeviceSettings';
import TRUS from './Trucker/UserSettings';

import {
  useAuth, useAuthRFS, useAuthULD, useAuthFTM, useAuthTKM, useAuthEmail, useAuthASR, useAuthHSR,
  useAuthAirline, useAuthHandler, useAuthTrucking, useAuthHRFS, useAuthForwarder,
  useAuthFSHP, useAuthFULD, useAuthTEmail, useAuthHSPL, useAuthTTracker, useAuthSAdmin, useAuthBroker,
  useAuthServer, useAuthFDVR, useAuthNTOKEN, useAuthQMS, useAuthHULD,
  useAuthHDVR, useAuthDVR 
} from '../../useAuth/useAuth';
import AddressBook from './ASR/AddressBook';


const Settings = () => {

  const shpTab = localStorage.getItem("FSTab");
  const SBack = localStorage.getItem('SettingsBack');

  const authMap = {
    airline: useAuthAirline(),
    uld: useAuthULD(),
    rfs: useAuthRFS(),
    asr: useAuthASR(),
    forwarder: useAuthForwarder(),
    fsm: useAuthFSHP(),
    fuld: useAuthFULD(),
    handler: useAuthHandler(),
    huld: useAuthHULD(),
    hspl: useAuthHSPL(),
    hsr: useAuthHSR(),
    dvr: useAuthDVR(), 
    trck: useAuthTrucking(), 
  };
  const AUTH_CONFIG = [
    { key: 'airline', defaultTab: 'user', url: '/Dashboard' },
    { key: 'uld', defaultTab: 'gen', url: '/ULDControl' },
    { key: 'rfs', defaultTab: 'not', url: '/BookingtruckSchedule' },
    { key: 'asr', defaultTab: 'gen', url: '/ServiceRecovery' },
    { key: 'forwarder', defaultTab: 'usr', url: '/Dashboard' },
    { key: 'fsm', defaultTab: 'gen', url: '/ForwarderShipments/Export' },
    { key: 'fuld', defaultTab: 'gen', url: '/ULDForwarder/ActiveTrips' },
    { key: 'handler', defaultTab: 'usr', url: '/HandlerAdmin' },
    { key: 'huld', defaultTab: 'air', url: '/ULDControl' },
    { key: 'hspl', defaultTab: 'drc', url: '/PlanningDashboard' },
    { key: 'hsr', defaultTab: 'stn', url: '/ServiceRecovery' },
    { key: 'dvr', defaultTab: 'gen', url: '/DVRegistration' },
    { key: 'trck', defaultTab: 'usr', url: '/Dashboard' },
  ];
  const getDefaultTab = () => {
    const auth = AUTH_CONFIG.find(a => authMap[a.key]);
    return auth?.defaultTab || null;
  };
  const getBackNav = AUTH_CONFIG.find(a => authMap[a.key]).url;
  const getBackUrl = () => {
    const auth = AUTH_CONFIG.find(a => authMap[a.key]);
    return auth?.url || null;
  };
  const initialTab = localStorage.getItem("STab") || getDefaultTab();
  const [selectedButton, setSelectedButton] = useState(initialTab);

  const handleTabChange = (tab) => {
    console.log('tab0', tab);
    localStorage.setItem('STab', tab)
    setSelectedButton(tab)
  }  

  return (
    <>
      <div className="">
        {(useAuthForwarder() && (selectedButton === 'tmz' || selectedButton === 'dvs')) || (authMap.fsm && selectedButton === 'gen') ?
          <Header
            logo_url={SBack ?? `/ForwarderShipments/${shpTab ? shpTab : "ShipmentRecords"}`}
            sBackUrl={SBack ?? `/ForwarderShipments/${shpTab ? shpTab : "ShipmentRecords"}`}
            hideIcon = {true}
          />
          :
          <Header logo_url={SBack ?? getBackNav} sBackUrl={SBack ?? getBackNav} mode={authMap.handler ? 'SAS' : ''} hideIcon = {true} />
        }
        <div className="main-panel">

          <div className="row">
            <LeftSettings onTab={handleTabChange} selectedTab={selectedButton} mode={authMap.handler ? 'HSA' : ''} />
            {useAuthAirline() &&
              <>
                {selectedButton === 'gen' && <AGS />}
                {selectedButton === 'user' && <CUS />}
                {selectedButton === 'station' && <ASS />}
                {selectedButton === 'template' && <ATM />}
              </>
            }
            {useAuthULD() &&
              <>
                {selectedButton === 'gen' && <AULDGS />}
                {selectedButton === 'reg' && <AULDRS />}
                {selectedButton === 'ars' && <AULDARS />}
                {selectedButton === 'not' && <AULDNS />}
                {selectedButton === 'ina' && <AULDIS />}
                {selectedButton === 'stn' && <AULDSS />}
                {selectedButton === 'rep' && <AULDRtS />}
                {selectedButton === 'msg' && <AULDMS />}
                {selectedButton === 'sas' && <AULDSAS />}
              </>
            }
            {useAuthRFS() &&
              <>
                {selectedButton === 'not' && <ARFSNS />}
                {selectedButton === 'trk' && <ARFSTS />}
                {selectedButton === 'stn' && <ARFSSS />}
                {selectedButton === 'uld' && <AULDS />}
                {selectedButton === 'reg' && <ARFSRS />}
              </>
            }
            {useAuthASR() &&
              <>
                {selectedButton === 'gen' && <ASRGS />}
                {selectedButton === 'stn' && <ASRRSS />}
                {selectedButton === 'fms' && <ASRFS />}
                {selectedButton === 'abs' && <AddressBook />}
                {selectedButton === 'dps' && <ASRDS />}
              </>
            }
            {useAuthForwarder() &&
              <>
                {selectedButton === 'usr' && <FUS />}
                {selectedButton === 'stn' && <FSS />}
                {selectedButton === 'dpt' && <FDS />}
                {selectedButton === 'tmz' && <FTS />}
                {selectedButton === 'dvs' && <FDVS />}
              </>
            }
            {useAuthFSHP() &&
              <>
                {selectedButton === 'gen' && <FSMGS />}
                {selectedButton === 'srs' && <FSMSRS />}
                {selectedButton === 'aci' && <FSMACI />}
                {selectedButton === 'crs' && <FSMCS />}
                {selectedButton === 'loc' && <FSMLS />}
                {selectedButton === 'qut' && <FSMQS />}
                {selectedButton === 'str' && <FSMSR />}
                {selectedButton === 'quto' && <FSMQO />}
              </>
            }
            {useAuthFULD() &&
              <>
                {selectedButton === 'gen' && <FULDGS />}
              </>
            }
            {useAuthHandler() &&
              <>
                {selectedButton === 'gen' && <HGS />}
                {selectedButton === 'usr' && <HUS />}
                {selectedButton === 'stn' && <HSS />}
                {selectedButton === 'wrh' && <HWS />}
                {selectedButton === 'tmt' && <HTM />}
                {selectedButton === 'tmz' && <FTS />}
              </>
            }
            {useAuthHULD() &&
              <>
                {selectedButton === 'air' && <HULDAirline />}
                {selectedButton === 'agt' && <HULDAgent />}
                {selectedButton === 'scm' && <HULDSCM />}
              </>
            }
            {useAuthHSPL() &&
              <>
                {selectedButton === 'drc' && <HSPLDC />}
                {selectedButton === 'slt' && <HSPLSS />}
                {selectedButton === 'trs' && <HSPLTS />}
                {selectedButton === 'ars' && <HSPLAS />}
                {selectedButton === 'rss' && <HSPLRS />}
              </>
            }
            {useAuthHSR() &&
              <>
                {selectedButton === 'gen' && <HSRGS />}
                {selectedButton === 'ads' && <HSRAB />}
                {selectedButton === 'stn' && <HSRRSS />}
              </>
            }
            {useAuthFDVR()  &&
              <>
                {selectedButton === 'gen' && <FDVDS />}
              </>
            }
            {useAuthHDVR()  &&
              <>
                {selectedButton === 'gen' && <FDVDS />}
              </>
            }
            {useAuthTrucking()  &&
              <>
                {selectedButton === 'usr' && <TRUS />}
              </>
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default Settings